import JSZip from 'jszip';
import type { JSZipObject } from 'jszip';
import type { LayerModel } from '../core/types';
import { parseKml } from './kmlParser';

const extension = (name: string): string => name.split('.').pop()?.toLowerCase() ?? '';

export function selectPrimaryKml(entries: readonly JSZipObject[]): JSZipObject | undefined {
  const candidates = entries.filter((entry) => !entry.dir && entry.name.toLowerCase().endsWith('.kml'));
  return candidates.sort((left, right) => {
    const normalizedLeft = left.name.replace(/\\/g, '/').replace(/^\.\//, '');
    const normalizedRight = right.name.replace(/\\/g, '/').replace(/^\.\//, '');
    const rank = (name: string): number => name.toLowerCase() === 'doc.kml' ? 0 : name.toLowerCase().endsWith('/doc.kml') ? 1 : 2;
    return rank(normalizedLeft) - rank(normalizedRight)
      || normalizedLeft.split('/').length - normalizedRight.split('/').length
      || normalizedLeft.localeCompare(normalizedRight, 'en', { sensitivity: 'base' });
  })[0];
}

export async function importGeodata(file: File): Promise<LayerModel> {
  const ext = extension(file.name);
  if (ext === 'kml') return parseKml(await file.text(), file.name, 'KML');
  if (ext === 'kmz') {
    const zip = await JSZip.loadAsync(await file.arrayBuffer());
    const kmlEntry = selectPrimaryKml(Object.values(zip.files));
    if (!kmlEntry) throw new Error('El KMZ no contiene un archivo KML.');
    return parseKml(await kmlEntry.async('string'), file.name, 'KMZ');
  }
  throw new Error('V0.1 admite archivos KML y KMZ.');
}
